var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.96875C0 0.76155 0.0790178 0.562836 0.21967 0.416323C0.360322 0.26981 0.551088 0.1875 0.75 0.1875H17.25C17.4489 0.1875 17.6397 0.26981 17.7803 0.416323C17.921 0.562836 18 0.76155 18 0.96875C18 1.17595 17.921 1.37466 17.7803 1.52118C17.6397 1.66769 17.4489 1.75 17.25 1.75H0.75C0.551088 1.75 0.360322 1.66769 0.21967 1.52118C0.0790178 1.37466 0 1.17595 0 0.96875ZM0 7.21875C0 7.01155 0.0790178 6.81284 0.21967 6.66632C0.360322 6.51981 0.551088 6.4375 0.75 6.4375H17.25C17.4489 6.4375 17.6397 6.51981 17.7803 6.66632C17.921 6.81284 18 7.01155 18 7.21875C18 7.42595 17.921 7.62466 17.7803 7.77118C17.6397 7.91769 17.4489 8 17.25 8H0.75C0.551088 8 0.360322 7.91769 0.21967 7.77118C0.0790178 7.62466 0 7.42595 0 7.21875ZM0 13.4688C0 13.2615 0.0790178 13.0628 0.21967 12.9163C0.360322 12.7698 0.551088 12.6875 0.75 12.6875H17.25C17.4489 12.6875 17.6397 12.7698 17.7803 12.9163C17.921 13.0628 18 13.2615 18 13.4688C18 13.676 17.921 13.8747 17.7803 14.0212C17.6397 14.1677 17.4489 14.25 17.25 14.25H0.75C0.551088 14.25 0.360322 14.1677 0.21967 14.0212C0.0790178 13.8747 0 13.676 0 13.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.0f94b9a5b466a8fec7e3320a11539f2e.svg";
export { ForwardRef as ReactComponent };